var cilBorderAll = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M56,472H456a16,16,0,0,0,16-16V56a16,16,0,0,0-16-16H56A16,16,0,0,0,40,56V456A16,16,0,0,0,56,472ZM272,72H440V240H272Zm0,200H440V440H272ZM72,72H240V240H72Zm0,200H240V440H72Z' class='ci-primary'/>"];

export { cilBorderAll };

